export interface ExpiringProductConfig {
	productVersionId: number;
	expiresAt: Date;
	label?: string;
}

/**
 * Productos con fecha de caducidad en el front: se sacan del payload antes de
 * mandarlo y se borran de cualquier carrito abierto en cada refresh.
 *
 * Está vacío a propósito. Aquí vivía el pv 1144 ("Regularización total"),
 * caducado el 3-may-2026 cuando se apagó aquella promo. El paquete
 * "Ponte al día" revive ese mismo SKU como línea contenedora, así que la
 * entrada se retiró: mientras estuvo, el contenedor se caía del carrito en
 * silencio —sin error, sin log— y sólo quedaban los periodos en $0 con un
 * total de $0.
 *
 * El mecanismo se queda para el próximo producto con fecha de caducidad.
 */
export const EXPIRING_PRODUCTS: ExpiringProductConfig[] = [];

export const isProductExpired = (
	productVersionId: number | undefined | null,
	now: Date = new Date(),
): boolean => {
	if (!productVersionId) return false;
	const config = EXPIRING_PRODUCTS.find(
		(p) => p.productVersionId === productVersionId,
	);
	if (!config) return false;
	return now.getTime() >= config.expiresAt.getTime();
};

export const filterExpiredShoppingItems = <
	T extends { id: number; product_version_id: number },
>(
	shoppingItems: T[] | undefined | null,
	now: Date = new Date(),
): T[] => {
	if (!shoppingItems?.length) return [];
	return shoppingItems.filter((item) =>
		isProductExpired(item.product_version_id, now),
	);
};

export const filterValidPayloadItems = <
	T extends { product_version_id?: number },
>(
	payload: T[] | undefined | null,
	now: Date = new Date(),
): T[] => {
	if (!payload?.length) return [];
	return payload.filter(
		(item) => !isProductExpired(item.product_version_id, now),
	);
};
